// app/composables/useCfgStorage.ts - 简易本地版本化缓存（localStorage）

const LS_VER = 'cfg.version'

function safeParse<T = any>(raw: string | null): T | null {
  if (!raw) return null
  try { return JSON.parse(raw) as T } catch { return null }
}

export interface StoredCfgItem { version: number; value: string }

export function useCfgStorage() {
  function getVersion(): number {
    if (import.meta.server) return 0
    return Number(localStorage.getItem(LS_VER) || 0)
  }

  function setVersion(v: number): void {
    if (import.meta.server) return
    localStorage.setItem(LS_VER, String(v))
  }

  function getItem(key: string): StoredCfgItem | null {
    if (import.meta.server) return null
    return safeParse<StoredCfgItem>(localStorage.getItem(`cfg.${key}`))
  }

  function setItem(key: string, version: number, value: string): void {
    if (import.meta.server) return
    localStorage.setItem(`cfg.${key}`, JSON.stringify({ version, value }))
  }

  /**
   * 当最新全局版本变动时，对比服务器返回的每个键的版本，清理已失效项并更新全局版本
   */
  function invalidateIfVersionChanged(latest: number, keyVersionMap: Record<string, number>): void {
    if (import.meta.server) return
    const cur = getVersion()
    if (latest <= cur) return
    for (const [k, v] of Object.entries(keyVersionMap)) {
      const it = getItem(k)
      if (it && it.version !== v) {
        localStorage.removeItem(`cfg.${k}`)
      }
    }
    setVersion(latest)
  }

  return { getVersion, setVersion, getItem, setItem, invalidateIfVersionChanged }
}

